import React, { useContext, useEffect } from "react";
import { getSortedContacts, initialContactFilter } from "./FilterTypes/ContactFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import ContactMultiPicker from "components/Picker/ContactPicker/ContactMultiPicker";

interface Props {
  title?: string
}

const ContactFitler = (props: Props) => {
  const title = props.title || site.currentEnvironment.contact.singular;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("contact", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedContacts(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedContacts.length > 0,
    reset: () => initialContactFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedContacts.map(c => c.contactId), b.selectedContacts.map(c => c.contactId))
  });
  useEffect(() => {
    setInitialValue("contact", initialContactFilter);
  }, []);

  const [selectedContacts, setSelectedContacts] = React.useState<server.dto.ContactSmallV2[]>(initialContactFilter.selectedContacts);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedContacts(getValue("contact").selectedContacts);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("contact", {
      selectedContacts
    });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <ContactMultiPicker
        selectedContacts={selectedContacts}
        onChange={setSelectedContacts}
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default ContactFitler;
